// extracted by mini-css-extract-plugin
export default {"wrapper":"BA-z","viewport":"CA-z","container":"DA-z","slide":"EA-z"};